import { jsx } from 'react/jsx-runtime';
import { memo, useContext } from 'react';
import { createGlobalReferenceContext } from '../utils/createGlobalReferenceContext.mjs';

const buildGlobalReferenceContext = (rootComponentName, defaultContext) => {
  const Context = createGlobalReferenceContext(
    `fx-${rootComponentName}`,
    defaultContext
  );
  function Provider(props) {
    const { children, ...value } = props;
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  }
  function useContext$1(consumerName) {
    const context = useContext(Context);
    if (context === null || context === void 0) {
      throw new Error(
        `${consumerName}\uC740 ${rootComponentName}\uD558\uC704\uC5D0\uC11C \uC0AC\uC6A9\uD574\uC57C \uD569\uB2C8\uB2E4.`
      );
    }
    return context;
  }
  Provider.displayName = `${rootComponentName}Provider`;
  return [memo(Provider), useContext$1];
};

export { buildGlobalReferenceContext };
//# sourceMappingURL=buildGlobalReferenceContext.mjs.map
